import { AreaDto, AreaGroupDto, CampusDto } from 'services/client-api-wrapper/campus_api/responses.dto';
import { OrgBrandingDto } from 'services/client-api-wrapper/identity_provider/responses.dto';
import { RoundTableSpeakerInfo } from 'features/Rooms/SpeakerStats/RoundTableStateManager';
import { IRoomResource } from 'kits/apiKit3/legacy';
import { atom } from 'recoil';
import { IInvitationsChanges } from './types';

export const aAPILanguage = atom<string | undefined>({ key: 'aAPILanguage', default: undefined });
export const aReviewInvitations = atom<boolean>({ key: 'aReviewInvitations', default: true });

export const aRoomList = atom<IRoomResource[]>({ key: 'aRoomList', default: [] });
export const aRoomListLoading = atom<boolean>({ key: 'aRoomListLoading', default: true });
/** Set after a successful room fetch; used to avoid loading flashes when ResourceAdapter remounts (e.g. /areas/:id vs /areas/:id/rooms/:rid). */
export const aLastRoomListFetchKey = atom<string | null>({ key: 'aLastRoomListFetchKey', default: null });

export const aHandRaiseButtonDisabled = atom<any>({ key: 'aHandRaiseButtonDisabled', default: false });
export const aRoundTableSpeakerList = atom<RoundTableSpeakerInfo[]>({ key: 'aRoundTableSpeakerList', default: [] });

export const aRoomListStyles = atom<any>({ key: 'aRoomListStyles', default: {} });
export const aSelectedVisitor = atom<string | undefined>({ key: 'aSelectedVisitor', default: undefined });

export const aCampus = atom<CampusDto | undefined>({ key: 'aCampus', default: undefined });
export const aAreaList = atom<AreaDto[]>({ key: 'aAreaList', default: [] });
/** True until campus area + area-group directory has finished loading for the current campus (see ResourceAdapter). */
export const aAreaDirectoryLoading = atom<boolean>({ key: 'aAreaDirectoryLoading', default: true });
export const aAreaGroupList = atom<AreaGroupDto[]>({ key: 'aAreaGroupList', default: [] });
export const aOrgBranding = atom<OrgBrandingDto | undefined>({ key: 'aOrgBranding', default: undefined });

export const aInvitationsChanges = atom<IInvitationsChanges[]>({ key: 'aInvitationsChanges', default: [] });

export const aCurrentSpeakerNameForTimer = atom<string>({ key: 'aCurrentSpeakerNameForTimer', default: '' });

export const aLastRoundTimeLeft = atom<number>({ key: 'aLastRoundTimeLeft', default: 0 });

export const aIsAttachmentActionBarButtonsVisible = atom<boolean>({ key: 'aIsAttachmentActionBarButtonsVisible', default: false });

export const aRefetchAreaAndAreaGroupList = atom<boolean>({ key: 'aRefetchAreaAndAreaGroupList', default: false });

export const aIsL1AreaGroupAvailable = atom<boolean>({ key: 'aIsL1AreaGroupAvailable', default: false });

export const aIsFavoritesDropdownVisible = atom<boolean>({ key: 'aIsFavoritesDropdownVisible', default: false });

export const aDeleteAreaOrAreaGroup = atom<{ id: string; name: string; parentAreaId?: string; isAreaGroup?: boolean }>({
    key: 'aDeleteAreaOrAreaGroup',
    default: { id: '', name: '', parentAreaId: undefined, isAreaGroup: undefined }
});

export const aEnabledWidgetProviders = atom<string[] | null>({
    key: 'aEnabledWidgetProviders',
    default: null
});

export const aHiddenDashboardWidgets = atom<string[]>({
    key: 'aHiddenDashboardWidgets',
    default: []
});
